import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardHeader } from "reactstrap";

import DeleteModal from "../../../../components/common/DeleteModal";

import DataTable from "react-data-table-component";
import { withTranslation } from "react-i18next";
import Loader from "../../../../components/common/Loader";
import NoRecords from "../../../../components/common/NoRecords";

import CustomAddButton from "../../../../components/common/CustomAddButton";
import CustomColumnHeader from "../../../../components/common/CustomColumnHeader";
import CustomSearchInput from "../../../../components/common/CustomSearchInput";
import CustomTooltipWrapper from "../../../../components/common/CustomTooltipWrapper";
import AddAuctionType from "../../../../components/pages/settings/AddAuctionType";
import {
  addAuctionTypes,
  deleteAuctionTypes,
  editAuctionTypes,
  getAuctionTypes,
} from "../../../../store/auction-types/actions";

const AuctionTypes = ({ t }) => {
  const dispatch = useDispatch();
  const { data: auctionTypesData, total: totalAuctionTypes } = useSelector((state) => state.AuctionTypes);

  const [auctionTypeListLoader, setAuctionTypeListLoader] = useState(false);
  const [isDeleteAuctiontypeModalOpen, setIsDeleteAuctionTypeModalOpen] = useState(false);
  const [isAddActionTypesModalOpen, setIsAddAuctionTypesModalOpen] = useState(false);
  const [auctionTypeDeleteLoader, setAuctionTypesDeleteLoader] = useState(false);
  const [auctionTypesSaveLoader, setAuctionTypesSaveLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [auctionTypesPayload, setAuctionTypesPayload] = useState({
    search: "",
    page: 1,
    limit: 10,
    filter: {
      id__icontains: "",
      code__icontains: "",
      auction_type__icontains: "",
    },
  });

  const [sortingOrder, setSortingOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");

  // setting title of the page
  document.title = `Veritas | ${t("sidebarMenu.auctionTypes")}`;

  // handle sorting functionality
  useEffect(() => {
    if (orderBy !== "" && sortingOrder !== "")
      setAuctionTypesPayload((prevState) => ({
        ...prevState,
        sort: sortingOrder === "asc" ? orderBy : sortingOrder === "desc" ? `${"-" + orderBy}` : "",
      }));
  }, [orderBy, sortingOrder]);

  // get list of auction types
  const handleGetAuctionTypeList = useCallback(
    (auctionTypesPayload) => {
      setAuctionTypeListLoader(true);
      dispatch(getAuctionTypes(auctionTypesPayload))
        .then((res) => {
          if (res) {
            //
          } else {
            //
          }
          setAuctionTypeListLoader(false);
        })
        .catch((error) => {
          setAuctionTypeListLoader(false);
        });
    },
    [dispatch]
  );

  useEffect(() => {
    handleGetAuctionTypeList(auctionTypesPayload);
  }, [auctionTypesPayload, handleGetAuctionTypeList]);

  const handleConfirmBtn = () => {
    setAuctionTypesDeleteLoader(true);
    dispatch(deleteAuctionTypes(selectedRow))
      .then((res) => {
        if (res) {
          //
          handleGetAuctionTypeList(auctionTypesPayload);
          setIsDeleteAuctionTypeModalOpen(false);
        } else {
          //
        }
        setAuctionTypesDeleteLoader(false);
      })
      .catch((error) => {
        setAuctionTypesDeleteLoader(false);
        setIsDeleteAuctionTypeModalOpen(false);
      });
  };

  const handleSaveAuctoinType = (values, validation) => {
    setAuctionTypesSaveLoader(true);
    if (selectedRow && selectedRow.id) {
      // dispatch for editing page
      dispatch(editAuctionTypes({ id: selectedRow.id, values }))
        .then((res) => {
          if (res) {
            handleGetAuctionTypeList(auctionTypesPayload);
            validation.resetForm();
            setIsAddAuctionTypesModalOpen(false);
            //
          } else {
            //
          }
          setAuctionTypesSaveLoader(false);
        })
        .catch((error) => {
          setIsAddAuctionTypesModalOpen(false);
          setAuctionTypesSaveLoader(false);
        });
    } else {
      // dispatch for adding new language
      dispatch(addAuctionTypes(values))
        .then((res) => {
          if (res) {
            handleGetAuctionTypeList(auctionTypesPayload);
            validation.resetForm();
            setIsAddAuctionTypesModalOpen(false);
            //
          } else {
            //
          }
          setAuctionTypesSaveLoader(false);
        })
        .catch((error) => {
          setIsAddAuctionTypesModalOpen(false);
          setAuctionTypesSaveLoader(false);
        });
    }
  };

  // handle page change
  const handlePageChange = (value) => {
    setAuctionTypesPayload((prevState) => ({
      ...prevState,
      page: value,
    }));
  };

  // handle rows per page change
  const handleRowsPerPageChange = (value) => {
    setAuctionTypesPayload((prevState) => ({
      ...prevState,
      limit: value,
    }));
  };

  const locationDeleteHandler = (row) => {
    setIsDeleteAuctionTypeModalOpen(true);
    setSelectedRow(row.id);
  };

  const locationEditHandler = (row) => {
    setIsAddAuctionTypesModalOpen(true);
    setSelectedRow(row);
  };

  const handleCloseBtn = () => {
    setIsDeleteAuctionTypeModalOpen(false);
  };

  const handleLocationModalOpen = () => {
    setSelectedRow(null);
    setIsAddAuctionTypesModalOpen(true);
  };

  const handleAuctionTypeModalClose = () => {
    setIsAddAuctionTypesModalOpen(false);
  };

  const columns = [
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">{t("common.id")}</div>
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="id__icontains"
            className="column-search-input"
            payload={auctionTypesPayload}
            setPayload={setAuctionTypesPayload}
          />
        </div>
      ),
      selector: (row) => row.id,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          {/* <div className="table-column-title mb-2">{t("common.code")}</div> */}
          <CustomColumnHeader
            columnTitle={t("common.code")}
            sortable
            sortableKey="code"
            orderBy={orderBy}
            sortingOrder={sortingOrder}
            setOrderBy={setOrderBy}
            setSortingOrder={setSortingOrder}
          />
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="code__icontains"
            className="column-search-input"
            payload={auctionTypesPayload}
            setPayload={setAuctionTypesPayload}
          />
        </div>
      ),
      selector: (row) => row.code,
      minWidth: "300px",
      wrap: true,
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          {/* <div className="table-column-title mb-2">
            {t("common.description")}
          </div> */}
          <CustomColumnHeader
            columnTitle={t("common.description")}
            sortable
            sortableKey="auction_type"
            orderBy={orderBy}
            sortingOrder={sortingOrder}
            setOrderBy={setOrderBy}
            setSortingOrder={setSortingOrder}
          />
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="auction_type__icontains"
            className="column-search-input"
            payload={auctionTypesPayload}
            setPayload={setAuctionTypesPayload}
          />
        </div>
      ),
      selector: (row) => row.auction_type,
      minWidth: "400px",
      wrap: true,
    },
    {
      name: (
        <div className="table-actions font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">{t("common.actions")}</div>
        </div>
      ),
      selector: (row) => (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">
            <div className="table-actions">
              <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode shadow-none"
                onClick={() => locationEditHandler(row)}
              >
                <CustomTooltipWrapper target={`tooltip-${row?.id}-edit`} tooltipBody={t("common.edit")} />
                <i className="ri-pencil-fill fs-18" id={`tooltip-${row?.id}-edit`} />
              </button>
              <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode shadow-none"
                onClick={() => locationDeleteHandler(row)}
              >
                <CustomTooltipWrapper target={`tooltip-${row?.id}-delete`} tooltipBody={t("common.delete")} />
                <i className=" ri-delete-bin-fill fs-18" id={`tooltip-${row?.id}-delete`} />
              </button>
            </div>
          </div>
        </div>
      ),
      minWidth: "150px",
      wrap: true,
      center: true,
    },
  ];

  return (
    <>
      <div className="page-content layout-main-container">
        <div className="container-header">
          <CustomSearchInput
            className="custom-search-input"
            payload={auctionTypesPayload}
            setPayload={setAuctionTypesPayload}
          />
          <div className="contain-header-right">
            <CustomAddButton
              color="success"
              onClick={handleLocationModalOpen}
              btnTitle={`${t("common.addTitle", {
                module: `${t("settings.auctions.auctionTypes.auctionType")}`,
              })}`}
            />
          </div>
        </div>
        <Card className="container-body">
          {auctionTypeListLoader ? <Loader /> : null}
          <CardHeader className="table-title">{t("sidebarMenu.auctionTypes")}</CardHeader>
          <DataTable
            fixedHeader
            className="data-table"
            // selectableRows
            columns={columns}
            data={[...auctionTypesData]}
            pagination
            paginationServer
            paginationTotalRows={totalAuctionTypes}
            noDataComponent={<NoRecords />}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={{
              rowsPerPageText: t("common.rowsPerPage"),
              rangeSeparatorText: t("common.rangeSeparator"),
            }}
            persistTableHead
          />
        </Card>
      </div>

      {/* to add /edit languages */}
      <AddAuctionType
        isModalOpen={isAddActionTypesModalOpen}
        auctionType={selectedRow}
        onCancel={handleAuctionTypeModalClose}
        onSave={handleSaveAuctoinType}
        loader={auctionTypesSaveLoader}
      />

      {/* delete modal for languages */}
      <DeleteModal
        title={`${t("common.delete")} ${t("settings.auctions.auctionTypes.auctionType")}`}
        body={t("confirmation.deleteMessage", {
          module: t("settings.auctions.auctionTypes.auctionType"),
        })}
        actionBtnTitle={`${t("common.delete")}`}
        loader={auctionTypeDeleteLoader}
        isModalOpen={isDeleteAuctiontypeModalOpen}
        onConfirmBtnHandler={handleConfirmBtn}
        onCloseBtnHandler={handleCloseBtn}
      />
    </>
  );
};

export default withTranslation()(AuctionTypes);
